import React, { Component } from "react";
import { withRouter } from "react-router-dom";

import PropTypes from "prop-types";
import { css } from "styled-components";
import { graphql } from "@apollo/client/react/hoc";
import compose from "lodash.flowright";
import { ADD_SPECIAL_PACK_INTEREST } from "../../../graphql/resolvers/specialPack";
import Button from "../Button";
import { GET_AUTH } from "../../../graphql/resolvers/auth";
import { FETCH_POLICY_CACHE_ONLY } from "../../../helpers/constants";
import { showErrorAlert, showInfoAlert } from "../../../helpers/alerts";
import { isLoggedIn } from "../../../helpers/auth";
import { logError } from "../../../helpers/logging";
import { fonts } from "../../../styles/variables";
import urlPatterns from "../../../urls";

const buttonStyle = css`
  font-family: ${fonts.fontBauMedium};
  min-height: 60px;
  cursor: pointer;
  font-size: 12px;
`;

class RegisterSpecialPackInterestButton extends Component {
  static propTypes = {
    registerInterestMutation: PropTypes.func.isRequired,
    specialPackEdition: PropTypes.shape({}).isRequired,
    authQuery: PropTypes.shape({}).isRequired,
    history: PropTypes.shape({}).isRequired,
  };

  state = {
    wasRegistered: false,
  };

  registerInterest = () => {
    const { registerInterestMutation, specialPackEdition, authQuery, history } = this.props;
    const { id, slug } = specialPackEdition;
    const { memberId } = authQuery.auth;

    if (!isLoggedIn()) {
      history.push(urlPatterns.LOGIN, {
        redirectUrl: urlPatterns.SPECIAL_PACK_DETAILS(slug),
      });
      return;
    }

    registerInterestMutation({
      variables: {
        input: {
          specialPackEditionId: id,
          memberId,
        },
      },
    })
      .then(({ data }) => {
        const { registerSpecialPackInterest } = data;
        if (registerSpecialPackInterest.isSuccessful) {
          showInfoAlert("We've registered your interest in this special pack.", { autoClose: 10000 });
          this.setState({ wasRegistered: true });
        }
      })
      .catch((error) => {
        logError(error);
        showErrorAlert("Sorry, something went wrong. Please try again.");
      });
  };

  render() {
    const { wasRegistered } = this.state;
    return (
      <Button
        type="button"
        onClick={this.registerInterest}
        hidden={wasRegistered}
        css={buttonStyle}
        {...this.props}
      >
        Register Interest
      </Button>
    );
  }
}

export default compose(
  graphql(ADD_SPECIAL_PACK_INTEREST, { name: "registerInterestMutation" }),
  graphql(GET_AUTH, {
    name: "authQuery",
    options: { fetchPolicy: FETCH_POLICY_CACHE_ONLY },
  })
)(withRouter(RegisterSpecialPackInterestButton));
